import GroupAddOutlined from '@mui/icons-material/GroupAddOutlined'
import {
  Alert,
  alpha,
  Avatar,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Stack,
  Typography,
} from '@mui/material'

import { useTranslation } from 'react-i18next'

interface NewCateringTeamOrderDialogProps {
  open: boolean
  /** When set (single-basket mode with a live draft), shown as a warning above the actions. */
  confirmationText?: string
  onCancel: () => void
  onConfirm: () => void
}

export function NewCateringTeamOrderDialog({
  open,
  confirmationText,
  onCancel,
  onConfirm,
}: NewCateringTeamOrderDialogProps) {
  const { t } = useTranslation()
  return (
    <Dialog
      open={open}
      onClose={onCancel}
      PaperProps={{
        sx: {
          borderRadius: '12px',
          width: 368,
          padding: 1,
        },
      }}>
      <Stack alignItems="center" sx={{ paddingTop: 2 }}>
        <Avatar
          aria-hidden
          sx={{
            width: 48,
            height: 48,
            bgcolor: (theme) => alpha(theme.palette.secondary.main, 0.16),
            color: 'secondary.main',
          }}>
          <GroupAddOutlined />
        </Avatar>
      </Stack>
      <DialogTitle sx={{ pb: 0.75, textAlign: 'center' }}>
        {t('marketplace:newCateringTeamOrder')}
      </DialogTitle>
      <DialogContent>
        <Stack spacing={1.5}>
          <Typography variant="body2" color="text.secondary" sx={{ lineHeight: 1.55 }}>
            {t('marketplace:newCateringTeamOrderDialogWhat')}
          </Typography>
          <Typography variant="body2" color="text.secondary" sx={{ lineHeight: 1.55 }}>
            {t('marketplace:newCateringTeamOrderDialogHow')}
          </Typography>
          <Typography variant="body2" color="text.secondary" sx={{ lineHeight: 1.55 }}>
            {t('marketplace:newCateringTeamOrderDialogControl')}
          </Typography>
          {confirmationText && (
            <Alert severity="warning" variant="outlined">
              {confirmationText}
            </Alert>
          )}
        </Stack>
      </DialogContent>
      {/* Still clickable while fading out, so a double click on Create would create twice. */}
      <DialogActions sx={{ px: 3, pb: 2, justifyContent: 'center' }}>
        <Button variant="outlined" onClick={onCancel} color="secondary" disabled={!open}>
          {t('common:cancel')}
        </Button>
        <Button variant="contained" color="secondary" onClick={onConfirm} disabled={!open}>
          {t('marketplace:newCateringTeamOrderCreate')}
        </Button>
      </DialogActions>
    </Dialog>
  )
}
